module.exports = __webpack_public_path__ + "img/组 4@2x.12ad532f.png";